import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import { NEW_SHELF_PATH, SHELF_PATH } from '../../../../config/paths';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';
import { SHELVES_COLUMNS } from '../../../../config/columns';
import { clearShelves, getShelves } from '../../../../actions/cargo/Shelf';

export const Shelves = ({
  breadcrumbs,
  shelves,
  loading,
  dispatchGetShelves,
  dispatchClearShelves,
}) => {
  useLayoutEffect(() => () => dispatchClearShelves(), []);

  const data = shelves.get('content') || [];
  const pages = shelves.get('totalPages') || null;
  const defaultPageSize = shelves.get('size') || DEFAULT_PAGE_SIZE;

  return (
    <ModuleList
      title="Anaqueles"
      breadcrumbs={breadcrumbs}
      buttonPath={NEW_SHELF_PATH}
      tableStructure={{
        columns: SHELVES_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetShelves,
        modelPath: SHELF_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetShelves: getShelves,
  dispatchClearShelves: clearShelves,
};

const mapStateToProps = ({ CargoUnit }) => ({
  breadcrumbs: [
    ...CargoUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Anaqueles',
      href: SHELF_PATH,
    },
  ],
  shelves: CargoUnit.Shelf.getIn(['all', 'content']),
  loading: CargoUnit.Shelf.getIn(['all', 'loading']),
});

Shelves.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  shelves: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetShelves: PropTypes.func.isRequired,
  dispatchClearShelves: PropTypes.func.isRequired,
};

Shelves.defaultProps = {
  shelves: null,
  loading: false,
};

export default connect(mapStateToProps, mapDispatchToProps)(Shelves);
